<div *ngIf="message == 'WARNING'" class="warning-bar error">
  Deine aktuellen Credits reichen für die Erstellung <span *ngIf="entity_type == 'ADVERT'">einer Marktplatzanzeige</span
  ><span *ngIf="entity_type == 'BLOG'">eines Blogbeitrags</span> leider nicht aus. Bitte melde dich bei unserem Support
  unter der Mail <a href="mailto:info@zimmerer-treff.com">info&#64;zimmerer-treff.com</a> um neue Credits zu bekommen.
</div>

<div *ngIf="message == 'INFO'" class="warning-bar info">
  Für die Erstellung des Beitrags über dein Firmenprofil berechnen wir dir {{ credits }} Credit(s). Deine aktuellen
  Credit(s): {{ company_profile.credits }}
</div>
